import React from "react";
import { Quotation } from "../../../../../stores/CoursePreviewStore/Types";
import AppliedVoucher from "../AppliedVoucher";
import PriceAmount from "../PriceAmount";

interface Props {
  activeQuote: Quotation;
  couponCode: string;
  refCode: string;
  refreshQuoteWithoutCoupon: (e: any) => void;
}

const Community: React.FC<Props> = ({
  activeQuote,
  couponCode,
  refCode,
  refreshQuoteWithoutCoupon,
}) => {
  return (
    <>
      <div id="priceBreakdown">
        <div className="price-line">
          <span>Monthly</span>
          <PriceAmount quote={activeQuote} />
        </div>
        <div className="price-line">
          <span>Billing</span>
          <span>Cancel anytime</span>
        </div>
        <AppliedVoucher
          couponCode={couponCode}
          refCode={refCode}
          refreshQuoteWithoutCoupon={refreshQuoteWithoutCoupon}
        />
        <div className="price-line total">
          <span>Today's charge</span>
          <PriceAmount quote={activeQuote} />
        </div>
      </div>
      <div className="whats-included" id="whatsIncluded">
        <h4>What you get</h4>
        <ul>
          <li>16,000+ member community</li>
          <li>Industry reports and swipe file</li>
          <li>AI toolkit (briefing tool, BeSci solver and more)</li>
          <li>Monthly live sessions</li>
          <li>Member-only content and discussions</li>
        </ul>
        <div
          className="whats-included"
          style={{ marginTop: "12px", paddingTop: "12px" }}
        >
          <h4>Available with All Courses Pass</h4>
          <ul>
            <li className="not-included">
              All 40+ CPD-accredited Mini MBA courses
            </li>
            <li className="not-included">
              Price locked in, never goes up while subscribed
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Community;
